import React from "react";
import { useTranslation } from "react-i18next";

// Faqat ma'lumot uchun: bosilmaydi, hover/active holati yo'q, filtr va tanlovlarga bog'liq emas
export default function AkfaSummaryCards({ summary }) {
    const { t } = useTranslation();
    if (!summary) return null;

    const cards = [
        { key: "newProductsCount", label: t("akfaIntegrationPage.summary.new_products"), color: "text-blue-700" },
        { key: "unmappedCount", label: t("akfaIntegrationPage.summary.needs_mapping"), color: "text-slate-600" },
        { key: "pendingPriceCount", label: t("akfaIntegrationPage.summary.pending_price_changes"), color: "text-amber-800" },
        { key: "needsReviewCount", label: t("akfaIntegrationPage.summary.needs_review"), color: "text-slate-700" },
        { key: "mappedCount", label: t("akfaIntegrationPage.summary.mapped"), color: "text-green-700" },
        { key: "ignoredCount", label: t("akfaIntegrationPage.summary.ignored"), color: "text-gray-500" },
        { key: "priceErrorCount", label: t("akfaIntegrationPage.summary.price_errors"), color: "text-red-700" },
        { key: "unsupportedPriceCount", label: t("akfaIntegrationPage.summary.unsupported_price"), color: "text-gray-700" },
    ];

    return (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-8 gap-2.5 mb-4">
            {cards.map((card) => (
                <div key={card.key} className="min-w-0 bg-white border border-gray-200 rounded-lg px-4 py-3.5">
                    <div className={`font-mono text-2xl font-semibold leading-tight tabular-nums ${card.color}`}>
                        {summary[card.key] ?? "—"}
                    </div>
                    <div className="text-xs text-gray-500 mt-1 leading-snug">{card.label}</div>
                </div>
            ))}
        </div>
    );
}
